import { Button, IconButton, Panel } from 'rsuite'
import { GetStaticProps, NextPage } from 'next'
import Link from 'next/link'
import ArrowLeftLineIcon from '@rsuite/icons/ArrowLeftLine'
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine'
import CenterLayout from '../../../components/shared/CenterLayout'
import CustomText from '../../../components/base/CustomText'
import { getSupportCategories } from '../../../services/supportServices'
import { SupportCategory } from '../../../ts/types/support.types'
import Pluralize from '../../../components/shared/Pluralize'

type Props = {
  categories: SupportCategory[]
}

const SupportGuidesPage: NextPage<Props> = ({ categories }) => {
  return (
    <CenterLayout maxWidth={900} showLogo>
      <Panel bodyFill shaded className="bg-white">
        <div className="px-8 pt-8 pb-4">
          <div className="border-b border-gray flex items-center gap-3 pb-4">
            <Link href="/help" passHref>
              <IconButton as="a" icon={<ArrowLeftLineIcon />} circle size="md" className="bg-gray-lightest" />
            </Link>
            <CustomText size="heading-4" weight={700} className="text-gray-darker">
              Guías de Ayuda
            </CustomText>
          </div>

          <CustomText size="paragraph" weight={400} className="text-gray-darker mt-5 mb-8">
            Aquí encontrarás guías paso a paso para ayudarte a resolver problemas comunes.
          </CustomText>

          <div className="divide-y divide-gray">
            {categories.map((category) => (
              <div key={category.id}>
                <div className="-mx-4">
                  <Link href={`/support/guides/${category.slug}`} passHref>
                    <Button appearance="subtle" size="lg" block>
                      <div className="flex items-center gap-8 text-left text-gray-darker">
                        <div className="flex-1 min-w-0">
                          <CustomText size="subtitle-2" weight={600} className="truncate">
                            {category.name}
                          </CustomText>
                          <CustomText size="caption" weight={400} className="truncate">
                            {category.description}
                          </CustomText>
                        </div>

                        <CustomText size="tiny" weight={400} className="text-gray-dark">
                          {category.guides_count}{' '}
                          <Pluralize count={category.guides_count} singular="guía" plural="guías" />
                        </CustomText>

                        <ArrowRightLineIcon />
                      </div>
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Panel>
    </CenterLayout>
  )
}

SupportGuidesPage.auth = false

// eslint-disable-next-line require-jsdoc
export const getStaticProps: GetStaticProps = async () => {
  const categories = await getSupportCategories()

  return {
    props: {
      categories,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 60, // In seconds
  }
}

export default SupportGuidesPage
